import { gql } from '@apollo/client'

export const GET_REWARDS = gql`
  query LoyaltyRewards($companyID: ID, $pagination: Pagination) {
    loyaltyRewards(pagination: $pagination, input: { companyID: $companyID }) {
      total
      items {
        company {
          id
          name
        }
        description
        id
        name
        type
        earnedCount
        redeemedCount
      }
    }
  }
`
export const GET_LOYALTY_CAMPAIGN_COMPANY = gql`
  query GetLoyaltyCampaign($campaignId: ID!) {
    loyaltyCampaign(input: { id: $campaignId }) {
      startAt
      company {
        id
      }
      companyLines {
        id
        name
      }
    }
  }
`

export const GET_LOYALTY_CAMPAIGN_RULE = gql`
  query GetLoyaltyCampaignRule($ruleId: ID!, $campaignId: ID!) {
    loyaltyCampaignRule(input: { id: $campaignId, ruleID: $ruleId }) {
      id
      name
      description
      details
      howToGet
      validAt
      effects {
        reward {
          id
          name
        }
      }
      conditions {
        routeServices {
          id
          code
        }
        citySegments {
          destination {
            id
            name
            code
          }
          origin {
            id
            name
            code
          }
          segments {
            id
            destination {
              code
              id
              name
            }
            origin {
              code
              id
              name
            }
          }
        }
        salesChannelsV2 {
          id
          name
        }
        totalBookingsValue
      }
    }
  }
`
